<template>
  <div class="xt-panel">
    <div class="xt-panel-title" v-if="plain">
      <div class="xt-panel-title-l" :class="classes">{{title}}</div>
      <div class="xt-panel-title-r">
        <span v-if="rightNote" class="xt-panel-title-note">{{rightNote}}</span>
        <router-link :to="route" class="xt-panel-title-tips">查看更多</router-link>
      </div>
    </div>
    <div class="xt-panel-title" v-else>
      <div class="no-border">{{title}}</div>
    </div>
    <div class="xt-panel-main">
      <ul class="xt-panel-title-sub clearfix pmtab" v-if="menu.length>0">
        <li v-for="(item,index) in menu" :key="index" @click="tabChange(index)" :class="{current:iscur==index}">{{item.name}}</li>
      </ul>
      <div class="xt-panel-main-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'panel',
  props: {
    //自定义类名，用于显示背景图片
    classes: {
      type: String,
      default: ""
    },
    //tab数组
    menu: {
      type: Array,
      default: function () {
        return []
      }
    },
    //是否启用简单面板头
    plain: {
      type: Boolean,
      default: true
    },
    //面板标题
    title: {
      type: String,
      default: ""
    },
    //menu当前活动current
    current: {
      type: Number,
      default: 0
    },
    //tab数组
    route: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // 右侧附加说明（红字），显示在最右侧
    rightNote: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      iscur: 0
    }
  },
  methods: {
    tabChange: function (index) {
      this.iscur = index
      this.$emit("change", index); //如果页面不需要底栏、就把状态传递给父组件
    },
  },
  watch: {
    'current': function (newVal) {
      console.log(newVal)
      this.iscur = newVal;
    }
  }
}
</script>
<style lang="scss" scoped>
.xt-panel {
  //面板标题
  .xt-panel-title {
    background: #fff;
    > div {
      height: 52px;
      line-height: 52px;
    }
    .no-border {
      font-size: 30px;
      color: #333333;
      position: relative;
      text-align: center;
      letter-spacing: 8px;
    }
    .xt-panel-title-l {
      float: left;
      font-size: 24px;
      color: #333333;
      position: relative;
      background-repeat: no-repeat;
      background-position: 100% center;
    }
    .zc {
      padding-right: 214px;
      background-image: url(../assets/image/Kongauction.png);
    }

    .zx {
      padding-right: 140px;
      background-image: url(../assets/image/ArtNews.png);
    }

    .dajp {
      padding-right: 240px;
      background-image: url(../assets/image/Everybodyclap.png);
    }
    .artist {
      padding-right: 100px;
      background-image: url(../assets/image/Artis.png);
    }
    .xt-panel-title-l {
      padding-left: 20px;
      &::before {
        display: block;
        content: "";
        width: 3px;
        height: 24px;
        background-color: #cfa972;
        position: absolute;
        top: 50%;
        left: 0px;
        transform: translate(0, -50%);
      }
    }
    .xt-panel-title-tips {
      float: right;
      color: #999999;
      margin-right: 15px;
    }
    .xt-panel-title-note {
      float: right;
      color: #bc230c;
      margin-right: 15px;
      font-size: 16px;
    }
  }
  //面板主体
  .xt-panel-main {
    padding-bottom: 20px;
  }
  .xt-panel-title-sub {
    list-style: none;
    padding: 0;
    margin-top: 20px;
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    align-items: center;
    -webkit-align-items: center;
    background-color: #fff;
    > li {
      float: left;
      color: #333;
      font-size: 22px;
      padding: 10px 0;
      cursor: pointer;
      position: relative;
    }
    > li.current {
      border-bottom: 4px solid #cfa972;
      &::before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        bottom: 0px;
        left: 50%;
        margin-left: -4px;
        border-bottom: 5px solid #cfa972;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
      }
    }
  }
}
</style>
